<div class="site-card">

    <!-- Site header row -->
    <div class="site-header" (click)="toggle()">
  
      <div class="site-header-left">
        <button class="toggle-btn" [class.open]="site.expanded">
          <svg width="10" height="6" viewBox="0 0 10 6">
            <path d="M1 1l4 4 4-4" stroke="#485760" stroke-width="1.4" fill="none" stroke-linecap="round"/>
          </svg>
        </button>
        <div class="site-name-col">
          <span class="site-name">{{ site.siteName }}</span>
        </div>
      </div>
  
      <div class="site-header-right">
        @for (et of eventTypeTotals; track et.eventType) {
          <div class="site-metric">
            <div class="metric-content">
              <span class="metric-val">{{ et.total }}</span>
              <span class="metric-label">{{ et.eventType }}</span>
            </div>
          </div>
        }
  
        <div class="site-metric">
          <img src="assets/images/billing/unit.svg" alt="" />
          <div class="metric-content">
            <span class="metric-val">{{ site.units }}</span>
            <span class="metric-label">{{ 'BILLING.UNITS' | translate }}</span>
          </div>
        </div>
  
        <div class="site-metric">
          <div class="metric-content">
            <span class="metric-val">{{ site.total }}</span>
            <span class="metric-label">{{ 'BILLING.TOTAL' | translate }}</span>
          </div>
        </div>
      </div>
  
    </div>
  
    <!-- Events details — mat-table -->
    @if (site.expanded) {
      <div class="events-wrap">
        <div class="events-title">{{ 'BILLING.EVENTS_DETAILS' | translate }}</div>
  
        <div class="events-scroll">
          <table class="table" mat-table [dataSource]="dataSource" matSort>
  
            <ng-container matColumnDef="bin">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">{{ 'BILLING.BIN' | translate }}</th>
              <td mat-cell *matCellDef="let element"><span class="bin-link">{{ element.bin }}</span></td>
            </ng-container>
  
            <ng-container matColumnDef="binType">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">{{ 'BILLING.BIN_TYPE' | translate }}</th>
              <td mat-cell *matCellDef="let element"><span class="td-value">{{ element.binType }}</span></td>
            </ng-container>
  
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">{{ 'BILLING.DATE' | translate }}</th>
              <td mat-cell *matCellDef="let element"><span class="td-value" dir="ltr">{{ element.date }}</span></td>
            </ng-container>
  
            <ng-container matColumnDef="eventType">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">{{ 'BILLING.EVENT_TYPE' | translate }}</th>
              <td mat-cell *matCellDef="let element"><span class="td-value">{{ element.eventType }}</span></td>
            </ng-container>
  
            <ng-container matColumnDef="units">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">{{ 'BILLING.UNITS' | translate }}</th>
              <td mat-cell *matCellDef="let element">
                <span class="td-value" [class.green-val]="element.units > 1">{{ element.units }}</span>
              </td>
            </ng-container>
  
            <ng-container matColumnDef="address">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">{{ 'BILLING.ADDRESS' | translate }}</th>
              <td mat-cell *matCellDef="let element"><span class="td-value td-address" [title]="element.address">{{ element.address }}</span></td>
            </ng-container>
  
            <ng-container matColumnDef="contract">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">{{ 'BILLING.CONTRACT' | translate }}</th>
              <td mat-cell *matCellDef="let element"><span class="td-value">{{ element.contract }}</span></td>
            </ng-container>
  
            <ng-container matColumnDef="amount">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">{{ 'BILLING.AMOUNT' | translate }}</th>
              <td mat-cell *matCellDef="let element">
                <span class="td-value amount-cell" [class.muted]="element.amount === '00.00 ILS'">{{ element.amount }}</span>
              </td>
            </ng-container>
  
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
  
      </div>
    }
  
  </div>
  